import { useState, useContext } from 'react';
import { Button, Typography, IconButton, Collapse } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AdminTestContext } from '@orientaction/Context';
import NoRecommendedTest from './NoRecommendedTest/index';
import RecommendedTestCard from './RecommendedTestCard';
import RecommendedTestDrawer from './RecommendedTestDrawer';
// import style from './style';

// Styles temporaires
const useStyles = {
  sectionTitle: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 700,
    color: '#FFFFFF',
    backgroundColor: '#000A8C',
    padding: '16px 24px',
    borderRadius: '8px',
    margin: 0,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  instructionContainer: {
    marginBottom: 20,
  },
  instructionTitle: {
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: 600,
    color: '#151528',
    marginBottom: 5,
  },
  instructionSubtitle: {
    fontFamily: 'Poppins',
    fontSize: 14,
    color: '#666',
    marginTop: 0,
    fontStyle: 'italic',
  },

  flexContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    margin: 10,
  },
  btnPrimary: {
    textTransform: 'none' as const,
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: '#000A8C',
    color: '#fff',
  },
  textHeader: {
    display: 'block',
  },
};

const RecommendedTestsSection = () => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const [isExpanded, setIsExpanded] = useState(true);

  const classes = useStyles;

  const handleAddTest = () => {
    updateTest({
      recommendedTestDrawer: {
        ...test.recommendedTestDrawer,
        open: true,
      },
    });
  };

  const canAddMoreTests = test.recommendedTests?.length < 10;

  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginTop: 35, marginBottom: 15 }}>
        <div style={classes.sectionTitle} onClick={() => setIsExpanded(!isExpanded)}>
          <Typography component="h1" style={{ color: '#FFFFFF', fontSize: 20, fontWeight: 700, fontFamily: 'Poppins' }}>
            Ajouter des tests recommandés
          </Typography>
          <IconButton style={{ color: '#FFFFFF', padding: '4px' }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      </div>
      
      <Collapse in={isExpanded}>
        <div style={classes.instructionContainer}>
          <Typography style={classes.instructionTitle} component="h2">
            Choisissez les tests recommandés
          </Typography>
          <Typography style={classes.instructionSubtitle} component="p">
            <em>(10 max.)</em>
          </Typography>
        </div>

                      {test?.recommendedTests?.length ? (
                <div>
                  {test.recommendedTests
                    .sort((a: any, b: any) => a.order - b.order)
                    .map((recommendedTest: any, index: number) => (
                      <RecommendedTestCard
                        key={recommendedTest.id}
                        test={recommendedTest}
                        index={index}
                      />
                    ))}
                </div>
              ) : (
                <NoRecommendedTest hasError={test?.errors?.recommendedTests} />
              )}

        {canAddMoreTests && (
          <div style={classes.flexContainer}>
            <Button onClick={handleAddTest} style={classes.btnPrimary}>
              <span style={classes.textHeader}>Ajouter un test recommandé</span>
            </Button>
          </div>
        )}
      </Collapse>

      <RecommendedTestDrawer />
    </div>
  );
};

export default RecommendedTestsSection; 